<!-- <div class="container">

  <div class="row">
     <div class="col-12">
       <h4>Login</h4>
     </div>

     <div class="col-12">
       <form #loginForm="ngForm" (ngSubmit)="login(loginForm)">

         <div class="row" *ngIf="authError">
           <div class="col-12 alert alert-danger">
             {{authError?.message}}
           </div>
         </div>

         <div class="row">
           <div class="col-md-6 mb-2">
             <label for="email">Email</label>
             <input ngModel #email="ngModel" name="email" type="text">
           </div>
           <div class="col-md-6 mb-2">
             <label for="password">password</label>
             <input ngModel #password="ngModel" name="password" type="text">
           </div>
         </div>
         <div class="form-group">
           <button type="submit" class="btn btn-lg btn-block btn-info">Submit</button>
         </div>

       </form>
     </div>
  </div>
  <!-- <div class="row">
     <div class="col-12">
       <h4>Registration</h4>
     </div>

     <div class="col-12">
       <div class="row" *ngIf="authError">
         <div class="col-12 alert alert-danger">
           {{authError?.message}}
         </div>
       </div>
       <form #userRegForm="ngForm" (ngSubmit)="createUser(userRegForm)">
         <div class="row">
           <div class="col-md-6 mb-2">
             <label for="firstName">First name</label>
             <input ngModel #firstName="ngModel" name="firstName" type="text">
           </div>
           <div class="col-md-6 mb-2">
             <label for="firstName">Last name</label>
             <input ngModel #lastName="ngModel" name="lastName" type="text">
           </div>
         </div>
         <div class="row">
           <div class="col-md-6 mb-2">
             <label for="email">Email</label>
             <input ngModel #email="ngModel" name="email" type="text">
           </div>
           <div class="col-md-6 mb-2">
             <label for="password">password</label>
             <input ngModel #password="ngModel" name="password" type="text">
           </div>
         </div>
         <div class="form-group">
           <button type="submit" class="btn btn-lg btn-block btn-info">Submit</button>
         </div>

       </form>
     </div>
  </div> -->
<!-- </div> --> -->
